<template>
  <div
    v-if="loading || (isAvailable && getSvg)"
    class="social-selling"
    :class="{ 'is-loading': loading }"
  >
    <span
      v-if="!loading"
      class="icon"
      :class="{ 'is-list': isList }"
      v-html="getSvg"
    />
    <span
      v-if="!loading"
      class="social-selling__text text-mobile-paragraph-s-regular text-desktop-paragraph-xs-regular"
      v-html="sellingElement.description"
    />
  </div>
</template>

<script>
/**
 * Vue: social selling (social-selling)
 * -----------------------------------------------------------------------------
 * Show customers recently bought count of other customers.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */
import { formatSvg } from '~/core/helpers/format-richtext';

export default {
  name: 'SocialSelling',

  props: {
    product: {
      type: Object,
      required: true,
    },
    sellingElement: {
      type: Object,
      default: () => ({}),
    },
    isList: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isAvailable() {
      return (
        !['back-soon', 'sold-out'].includes(this.product.availableState) &&
        this.product.available
      );
    },

    /**
     * Get SVG code from image url via request.
     * - If the image is not SVG, return false.
     */
    getSvg() {
      try {
        if (!this.sellingElement?.icon?.includes('.svg')) {
          return false;
        }
        const svgCode = formatSvg(this.sellingElement.icon);
        return svgCode;
      } catch (error) {
        cnvs.ReportError('Error formatting SVG:', error);
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import './social-selling';
</style>
